import type { AuthHandlerContract } from '@sparklayer-io/spark-dash-core/types/handlers/auth';
import { useAuthStore } from '../session';

export const authHandler: AuthHandlerContract = {
  refreshUser() {
    void useAuthStore.getState().loadUser(true);
  },
  changeSite(teamId) {
    return useAuthStore.getState().changeSite(teamId);
  },
  reloadUser() {
    return useAuthStore.getState().loadUser(true);
  },
  logout() {
    return useAuthStore.getState().logout();
  },
};
